// Additional waste items for expanded database (100+ new items)

export const additionalWasteItems = [
  // Electronics & Technology
  {
    name: 'Batai',
    container: 'Tekstilė',
    description: 'Senus batus galima atiduoti į specialius tekstilės konteinerius arba pristatyti į tekstilės atliekų surinkimo punktus.',
  },
  {
    name: 'Drabužiai',
    container: 'Tekstilė',
    description: 'Naudoti drabužiai turi būti sukrauti į tekstilės konteinerius. Drabužiai turi būti švarūs ir sausi.',
  },
  {
    name: 'Katilas elektrinis',
    container: 'Elektronika',
    description: 'Elektrinis katilas priskiriamas elektros ir elektroninės įrangos atliekoms. Pristatykite į elektronikos atliekų surinkimo punktus.',
  },
  {
    name: 'Dulkių siurblys',
    container: 'Elektronika',
    description: 'Dulkių siurblys yra elektros prietaisas ir turi būti pristatytas į elektronikos atliekų surinkimo punktą.',
  },
  {
    name: 'Mikrobangų krosnelė',
    container: 'Elektronika',
    description: 'Mikrobangų krosnelė priskiriama elektronikos atliekoms. Pristatykite į elektronikos atliekų surinkimo punktus.',
  },
  {
    name: 'Šaldytuvas',
    container: 'Elektronika',
    description: 'Šaldytuvai turi būti pristatyti į elektronikos atliekų surinkimo punktus. Jie tvarkomi ypatingai dėl freono.',
  },
  {
    name: 'Skalbimo mašina',
    container: 'Elektronika',
    description: 'Skalbimo mašina yra stambi buitinė technika ir priskiriama elektronikos atliekoms.',
  },
  {
    name: 'Televizorius',
    container: 'Elektronika',
    description: 'Televizoriai, monitoriai ir ekranai yra elektronikos atliekos. Pristatykite į specialius surinkimo punktus.',
  },
  {
    name: 'Kompiuteris',
    container: 'Elektronika',
    description: 'Kompiuteriai, planšetės, nešiojamieji kompiuteriai yra elektronikos atliekos.',
  },
  {
    name: 'Mobilusis telefonas',
    container: 'Elektronika',
    description: 'Mobilieji telefonai ir jų akumuliatoriai yra elektronikos atliekos. Priimama parduotuvėse.',
  },
  {
    name: 'Ausinės',
    container: 'Elektronika',
    description: 'Laidinės ir belaidės ausinės priskiriamos smulkiai elektronikai.',
  },
  {
    name: 'Įkroviklis',
    container: 'Elektronika',
    description: 'Telefonų, planšečių, kompiuterių įkrovikliai yra elektronikos atliekos.',
  },
  {
    name: 'USB kabeliai',
    container: 'Elektronika',
    description: 'Elektros laidai, USB kabeliai ir kiti kabeliai yra elektronikos atliekos.',
  },
  {
    name: 'Baterijos',
    container: 'Pavojingos',
    description: 'Baterijos ir akumuliatoriai yra pavojingos atliekos. Priduokite parduotuvėse arba surinkimo punktuose.',
  },
  {
    name: 'Spausdintuvas',
    container: 'Elektronika',
    description: 'Spausdintuvai, skeneriai ir kopijavimo aparatai yra elektronikos atliekos.',
  },
  {
    name: 'Klaviatūra',
    container: 'Elektronika',
    description: 'Kompiuterio klaviatūros ir pelės yra smulki elektronika.',
  },
  {
    name: 'Plaukų džiovintuvas',
    container: 'Elektronika',
    description: 'Plaukų džiovintuvai, tiesinimo įtaisai yra elektronikos atliekos.',
  },
  {
    name: 'Elektrinis skustuvas',
    container: 'Elektronika',
    description: 'Elektriniai skutimosi aparatai priskiriami smulkiai elektronikai.',
  },
  
  // Lighting
  {
    name: 'Fluorescencinė lempa',
    container: 'Pavojingos',
    description: 'Fluorescencinės lempos turi gyvsidabrio ir yra pavojingos. Priduokite į specialius surinkimo punktus.',
  },
  {
    name: 'LED lemputė',
    container: 'Elektronika',
    description: 'LED lemputės yra elektronikos atliekos. Priduokite elektronikos surinkimo punktuose.',
  },
  {
    name: 'Kaitrinė lemputė',
    container: 'Mišrios atliekos',
    description: 'Paprastos kaitrinės lemputės gali būti metamos į mišrių atliekų konteinerį.',
  },
  
  // Hazardous items
  {
    name: 'Termometras gyvsidabrinis',
    container: 'Pavojingos',
    description: 'Gyvsidabriniai termometrai yra labai pavojingi. Pristatykite į pavojingų atliekų punktus arba vaistines.',
  },
  {
    name: 'Padangos',
    container: 'Pavojingos',
    description: 'Automobilių padangos priduodamos padangų surinkimo punktuose arba servise.',
  },
  {
    name: 'Auto akumuliatorius',
    container: 'Pavojingos',
    description: 'Automobilių akumuliatoriai yra pavojingos atliekos. Priduokite servise.',
  },
  {
    name: 'Variklio aliejus',
    container: 'Pavojingos',
    description: 'Naudotas variklio aliejus yra pavojingas. Pristatykite į pavojingų atliekų punktus.',
  },
  {
    name: 'Dujų balionėlis',
    container: 'Pavojingos',
    description: 'Dujų balionėliai yra pavojingos atliekos. Pristatykite į pavojingų atliekų aikšteles.',
  },
  {
    name: 'Gesintuvas',
    container: 'Pavojingos',
    description: 'Senus gesintuvus reikia priduoti specialioms įmonėms.',
  },
  
  // Furniture & Large items
  {
    name: 'Mediniai baldai',
    container: 'Pavojingos',
    description: 'Dideli mediniai baldai pristatomi į stambiagabaričių atliekų aikšteles.',
  },
  {
    name: 'Čiužinys',
    container: 'Pavojingos',
    description: 'Čiužiniai yra stambiagabaritės atliekos ir pristatomi į aikšteles.',
  },
  {
    name: 'Kilimas',
    container: 'Tekstilė',
    description: 'Senus kilimus pristatykite į stambiagabaričių atliekų aikšteles.',
  },
  {
    name: 'Užuolaidos',
    container: 'Tekstilė',
    description: 'Senus užuolaidas priduokite į tekstilės konteinerius. Jos turi būti švarios.',
  },
  {
    name: 'Rankšluosčiai',
    container: 'Tekstilė',
    description: 'Naudoti rankšluosčiai, jei švarūs, metami į tekstilės konteinerius.',
  },
  {
    name: 'Patalynė',
    container: 'Tekstilė',
    description: 'Sena patalynė gali būti metama į tekstilės konteinerius.',
  },
  {
    name: 'Pagalvė',
    container: 'Mišrios atliekos',
    description: 'Seną pagalvę galima mesti į mišrių atliekų konteinerį.',
  },
  {
    name: 'Antklodė',
    container: 'Tekstilė',
    description: 'Sena antklodė, jei švari, metama į tekstilės konteinerį.',
  },
  
  // Paper & Office
  {
    name: 'Žurnalai',
    container: 'Popierius',
    description: 'Žurnalai ir katalogai metami į popieriaus konteinerį. Sąvaržėlių išimti nereikia.',
  },
  {
    name: 'Sąsiuviniai',
    container: 'Popierius',
    description: 'Sąsiuviniai ir užrašų knygelės metami į popieriaus konteinerį.',
  },
  {
    name: 'Vokai su langeliu',
    container: 'Popierius',
    description: 'Vokai su plastikiniu langeliu metami į popieriaus arba mišrių pakuočių konteinerį.',
  },
  {
    name: 'Kalendoriai',
    container: 'Popierius',
    description: 'Popieriniai kalendoriai metami į popieriaus konteinerį. Metalinius žiedus galima palikti.',
  },
  {
    name: 'Lipdukai',
    container: 'Mišrios atliekos',
    description: 'Lipdukai dažniausiai iš plastiko, todėl metami į mišrių atliekų konteinerį.',
  },
  
  // Disposable items
  {
    name: 'Popierinis kavos puodelis',
    container: 'Plastikas',
    description: 'Vienkartiniai kavos puodeliai padengti plastiku, todėl metami į plastiko konteinerį.',
  },
  {
    name: 'Plastikiniai šiaudeliai',
    container: 'Plastikas',
    description: 'Plastikiniai šiaudeliai metami į plastiko konteinerį, bet geriau jų vengti.',
  },
  {
    name: 'Popieriniai šiaudeliai',
    container: 'Popierius',
    description: 'Popieriniai šiaudeliai metami į popieriaus konteinerį, jei nesutepti.',
  },
  
  // Household items
  {
    name: 'Šluota',
    container: 'Mišrios atliekos',
    description: 'Seną šluotą galima mesti į mišrių atliekų konteinerį.',
  },
  {
    name: 'Plastikinis kibiras',
    container: 'Plastikas',
    description: 'Plastikinis kibiras metamas į plastiko konteinerį, jei nesuteptas cheminėmis medžiagomis.',
  },
  {
    name: 'Metalinis kibiras',
    container: 'Plastikas',
    description: 'Metalinis kibiras metamas į metalo arba mišrių pakuočių konteinerį.',
  },
  {
    name: 'Puodas',
    container: 'Pavojingos',
    description: 'Metaliniai puodai ir keptuvės pristatomi į stambiagabaričių atliekų aikšteles.',
  },
  {
    name: 'Keptuvė',
    container: 'Pavojingos',
    description: 'Senas keptuve su antiadheziniu padengimu pristatykite į aikštelę.',
  },
  {
    name: 'Stikliniai indai maistui',
    container: 'Stiklas',
    description: 'Stikliniai maisto laikymo indai metami į stiklo konteinerį.',
  },
  {
    name: 'Plastikiniai indai maistui',
    container: 'Plastikas',
    description: 'Plastikiniai maisto laikymo indai metami į plastiko konteinerį su perdirbimo ženklu.',
  },
  {
    name: 'Kempinė indams',
    container: 'Mišrios atliekos',
    description: 'Kempinės indams plauti yra neperdirbamos ir metamos į mišrių atliekų konteinerį.',
  },
  {
    name: 'Šepetys indams',
    container: 'Mišrios atliekos',
    description: 'Šepetėliai indams plauti metami į mišrių atliekų konteinerį.',
  },
  {
    name: 'Zip-lock maišeliai',
    container: 'Plastikas',
    description: 'Plastikiniai maišeliai su užtrauktuku metami į plastiko konteinerį, jei švarūs.',
  },
  {
    name: 'Aliuminė folija',
    container: 'Plastikas',
    description: 'Aliuminė folija, jei švari, metama į plastiko arba metalo pakuočių konteinerį.',
  },
  {
    name: 'Maišeliai nuo duonos',
    container: 'Plastikas',
    description: 'Plastikiniai maišeliai nuo duonos metami į plastiko konteinerį.',
  },
  
  // Media & Storage
  {
    name: 'CD/DVD diskai',
    container: 'Mišrios atliekos',
    description: 'Kompaktiniai diskai yra neperdirbami ir metami į mišrių atliekų konteinerį.',
  },
  {
    name: 'CD/DVD dėklai',
    container: 'Plastikas',
    description: 'Plastikiniai CD/DVD dėklai metami į plastiko konteinerį.',
  },
  
  // Food packaging
  {
    name: 'Cukraus popierinis maišelis',
    container: 'Popierius',
    description: 'Popieriniai maišeliai nuo cukraus, miltų metami į popieriaus konteinerį, jei nesutepti.',
  },
  
  // Organic/Bio waste
  {
    name: 'Arbatos maišeliai',
    container: 'Bio atliekos',
    description: 'Arbatos maišeliai metami į biologinių atliekų konteinerį arba kompostuojami.',
  },
  {
    name: 'Kavos tirščiai',
    container: 'Bio atliekos',
    description: 'Kavos tirščiai gali būti kompostuojami arba metami į biologinių atliekų konteinerį.',
  },
  {
    name: 'Vaisių likučiai',
    container: 'Bio atliekos',
    description: 'Vaisių ir daržovių likučiai gali būti kompostuojami arba metami į bio atliekų konteinerį.',
  },
  {
    name: 'Žolės nukirtimas',
    container: 'Bio atliekos',
    description: 'Nukirstą žolę galima kompostuoti arba vežti į žalių atliekų aikšteles.',
  },
  {
    name: 'Lapai',
    container: 'Bio atliekos',
    description: 'Kritę lapai gali būti kompostuojami arba vežami į žalių atliekų aikšteles.',
  },
  {
    name: 'Šakos',
    container: 'Bio atliekos',
    description: 'Medžių šakos ir sodininkystės atliekos vežamos į žalių atliekų aikšteles.',
  },
  {
    name: 'Gėlių žemė',
    container: 'Bio atliekos',
    description: 'Sena gėlių žemė gali būti kompostuojama arba vežama į žalių atliekų aikšteles.',
  },
  {
    name: 'Moliniai vazonai',
    container: 'Pavojingos',
    description: 'Moliniai vazonai yra keramikos atliekos ir vežami į stambiagabaričių atliekų aikšteles.',
  },
  {
    name: 'Plastikiniai vazonai',
    container: 'Plastikas',
    description: 'Plastikiniai gėlių vazonai metami į plastiko konteinerį.',
  },
  
  // Construction & DIY
  {
    name: 'Cemento maišas',
    container: 'Pavojingos',
    description: 'Tušti cemento maišai vežami į statybinių atliekų aikšteles.',
  },
  {
    name: 'Plytos',
    container: 'Pavojingos',
    description: 'Plytos ir kitos statybinės atliekos vežamos į statybinių atliekų aikšteles.',
  },
  {
    name: 'Keramikos plytelės',
    container: 'Pavojingos',
    description: 'Keramikos plytelės vežamos į stambiagabaričių atliekų aikšteles.',
  },
  {
    name: 'Gipsas',
    container: 'Pavojingos',
    description: 'Gipso atliekos vežamos į statybinių atliekų aikšteles.',
  },
  {
    name: 'Medžio drožlės',
    container: 'Bio atliekos',
    description: 'Šviežios medžio drožlės gali būti kompostuojamos, jei nechemiškai apdorotos.',
  },
  
  // Pet supplies
  {
    name: 'Katės kraikas',
    container: 'Mišrios atliekos',
    description: 'Naudotas katės kraikas metamas į mišrių atliekų konteinerį.',
  },
  {
    name: 'Gyvūno maisto skardinė',
    container: 'Plastikas',
    description: 'Metalinės gyvūnų maisto skardinės metamos į metalo arba mišrių pakuočių konteinerį.',
  },
  {
    name: 'Gyvūno maisto pakuotė plastikinė',
    container: 'Plastikas',
    description: 'Plastikinės gyvūnų maisto pakuotės metamos į plastiko konteinerį.',
  },
  
  // Personal care
  {
    name: 'Skutimosi putos skardinė',
    container: 'Plastikas',
    description: 'Tuščios aerozolinės skardinės metamos į plastiko arba metalo pakuočių konteinerį.',
  },
  {
    name: 'Dezodorantas',
    container: 'Plastikas',
    description: 'Tušti dezodorantai metami į plastiko arba mišrių pakuočių konteinerį.',
  },
  {
    name: 'Parfumo buteliukas',
    container: 'Stiklas',
    description: 'Stikliniai parfumo buteliukai metami į stiklo konteinerį.',
  },
  {
    name: 'Kosmetikos tūbelė',
    container: 'Plastikas',
    description: 'Ištuštintos kosmetikos tūbelės metamos į plastiko konteinerį.',
  },
  {
    name: 'Makiažo pakuotė',
    container: 'Plastikas',
    description: 'Plastikinės makiažo pakuotės metamos į plastiko konteinerį.',
  },
  {
    name: 'Šampūno butelis',
    container: 'Plastikas',
    description: 'Tušti šampūno buteliai metami į plastiko konteinerį.',
  },
  {
    name: 'Kondicionieriaus butelis',
    container: 'Plastikas',
    description: 'Tušti kondicionieriaus buteliai metami į plastiko konteinerį.',
  },
];
